<span class="group/tooltip relative inline-flex">
  <ng-content />
  <span
    class="pointer-events-none absolute bottom-full left-1/2 z-50 mb-2 w-max max-w-[240px] -translate-x-1/2 rounded-lg border border-white/10 bg-surface-container-highest px-3 py-2 text-center font-game-answer text-sm text-on-surface opacity-0 shadow-[0_4px_16px_rgba(0,0,0,0.5)] transition-opacity duration-150 group-hover/tooltip:opacity-100"
    role="tooltip"
    >{{ text() }}</span
  >
</span>
